module.exports = __webpack_public_path__ + "static/media/zavod.1d77fbf2.jpg";